"use client";

import { useEffect, useRef } from "react";
import { track } from "@/lib/tracking";

/**
 * Fires view_section once when the element is >=50% visible.
 * Spec: admin.teado.ai/#events — section: hero|features|partners|reviews
 */
export function useTrackSection<T extends HTMLElement = HTMLElement>(
  sectionName: string
) {
  const ref = useRef<T>(null);
  const fired = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !fired.current) {
          fired.current = true;
          track("view_section", { section: sectionName });
          obs.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [sectionName]);

  return ref;
}
